"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESTAURANT_LOGIN = exports.FOR_RESTAURANTS_MOBILE_URL = exports.FOR_RESTAURANTS_DESKTOP_URL = exports.GET_THE_APP_URL = exports.DOWNLOAD_APP_URL = exports.HELP_URL = exports.REGISTRATION_REDIRECT_URL = exports.CANCELED_SUPPORT_URL = exports.CCPA_URL = exports.COOKIES_URL = exports.PRIVACY_URL = exports.TERMS_URL = exports.CHOWNOW_URL = exports.BASE_SUPPORT_URL = exports.BASE_CHOWNOW_URL = void 0;
const BASE_CHOWNOW_URL = 'https://get.chownow.com';
exports.BASE_CHOWNOW_URL = BASE_CHOWNOW_URL;
const BASE_SUPPORT_URL = 'https://support.chownow.com';
exports.BASE_SUPPORT_URL = BASE_SUPPORT_URL;
const UTM_PARAMS = '?utm_source=product&utm_medium=orderdirect&utm_campaign=poweredbyfooter';
const CHOWNOW_URL = "".concat(BASE_CHOWNOW_URL, "/").concat(UTM_PARAMS);
exports.CHOWNOW_URL = CHOWNOW_URL;
const TERMS_URL = "".concat(BASE_CHOWNOW_URL, "/terms-of-service");
exports.TERMS_URL = TERMS_URL;
const PRIVACY_URL = "".concat(BASE_CHOWNOW_URL, "/privacy-policy");
exports.PRIVACY_URL = PRIVACY_URL;
const COOKIES_URL = "".concat(BASE_CHOWNOW_URL, "/cookie-notice"); // eslint-disable-next-line max-len

exports.COOKIES_URL = COOKIES_URL;
const CCPA_URL = "https://chownow-requests.my.onetrust.com/webform/67994022-0d2e-4da4-af0f-30b990afab7a/b16058fc-4ca6-4d7a-a18d-d18b292f7d11"; // eslint-disable-next-line max-len

exports.CCPA_URL = CCPA_URL;
const CANCELED_SUPPORT_URL = "".concat(BASE_SUPPORT_URL, "/customer/s/topic/0TO4A000000g8gzWAA/declined-canceled-orders"); // eslint-disable-next-line max-len

exports.CANCELED_SUPPORT_URL = CANCELED_SUPPORT_URL;
const REGISTRATION_REDIRECT_URL = "".concat(BASE_CHOWNOW_URL, "/registration-error?utm_source=qtc&utm_medium=organic&utm_campaign=redirect");
exports.REGISTRATION_REDIRECT_URL = REGISTRATION_REDIRECT_URL;
const HELP_URL = "".concat(BASE_SUPPORT_URL, "/customer/s/");
exports.HELP_URL = HELP_URL;
const DOWNLOAD_APP_URL = 'https://chownow.app.link/download-chownow-app-side-menu';
exports.DOWNLOAD_APP_URL = DOWNLOAD_APP_URL;
const GET_THE_APP_URL = 'https://chownow.app.link/chownow-app-download';
exports.GET_THE_APP_URL = GET_THE_APP_URL;
const FOR_RESTAURANTS_DESKTOP_URL = 'https://get.chownow.com/?utm_medium=desktop_auth_dropdown&utm_source=marketplace_web';
exports.FOR_RESTAURANTS_DESKTOP_URL = FOR_RESTAURANTS_DESKTOP_URL;
const FOR_RESTAURANTS_MOBILE_URL = 'https://get.chownow.com/?utm_medium=mobile_side_menu&utm_source=marketplace_web';
exports.FOR_RESTAURANTS_MOBILE_URL = FOR_RESTAURANTS_MOBILE_URL;
const RESTAURANT_LOGIN = 'https://admin.chownow.com/admin/login?next=https%3A%2F%2Fdashboard.chownow.com';
exports.RESTAURANT_LOGIN = RESTAURANT_LOGIN;